// extracted by mini-css-extract-plugin
export default {"link_container":"NavLink_link_container__g0DIE","single_link_cont":"NavLink_single_link_cont__oJXKG","span_orange":"NavLink_span_orange__OuOvd"};